import { compose } from 'recompose'
import withComposedClassName from 'src/composables/withComposedClassName'
import omitProps from 'src/composables/omitProps'

import styles from './Header.module.scss'

const Header = withComposedClassName(styles.root)('header')

export const Content = withComposedClassName(styles.content)('div')

export const Navigation = compose(
  withComposedClassName(({ loaded }) => [
    styles.navigation,
    loaded && styles.loaded
  ]),
  omitProps('loaded')
)('div')

export const Actions = withComposedClassName(styles.actions)('div')

export const SubHeader = withComposedClassName(styles.subheader)(Header)

export const SubHeaderContent = withComposedClassName(styles.subheaderContent)(
  Content
)

export default Header
